import React from 'react';
import { Box, Theme, Typography } from '@mui/material';
import { ButtonDefault } from '../../shared/components/ButtonDefault';
import { useNavigate } from 'react-router-dom';
import { createStyles, makeStyles } from '@mui/styles';
import { Header } from '../../shared/components/layout/user/Header';

const useStyles = makeStyles<Theme>(() =>
  createStyles({
    back: {
      width: 180,
    },
    container: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100vh',
    },
    root: {
      flexGrow: 1,
      display: 'flex',
      marginTop: '100px',
      alignItems: 'center',
      justifyContent: 'center',
    },
    body: {},
  }),
);

type ErrorViewProps = {
  text?: string;
};
export const ErrorView: React.FC<ErrorViewProps> = ({
  text = 'No tienes permisos para acceder a esta página',
}) => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <Box className={classes.container}>
      <Header />
      <main className={classes.root}>
        <Box textAlign="center">
          <Typography variant="h1" fontWeight={800} mb={1}>
            404
          </Typography>
          <Typography variant="h5" fontWeight={800} mb={1}>
            {text}
          </Typography>
          <ButtonDefault className={classes.back} onClick={() => navigate(-1)}>
            Volver
          </ButtonDefault>
        </Box>
      </main>
    </Box>
  );
};
